export default {
  'signin': 'Connexion',
  'signin-action': 'Se Connecter',
  'forgot-password': 'Mot de passe oublié ?',
  'ask-new-password': 'Réinitialiser le mot de passe',
  'reset-password': 'Nouveau mot de passe',
  'save-password': 'Enregistrer',
  'invalid-mail': 'Veuillez saisir une adresse e-mail valide',
  'password-check': 'Votre mot de passe doit contenir au moins un chiffre, une majuscule, une minuscule et 8 caractères'
}



// WEBPACK FOOTER //
// ./src/translations/fr/authentification.js